import { useState } from 'react';
import { Modal, ModalBody, ModalFooter, Button, ModalHeader } from 'src/components/ui';
import { Trans } from '@lingui/react/macro';
import { getTestId } from '../../hooks/useTestId';

const PARAMS = ['title', 'message'];

function NumberEntryModal({ title, message, onCancel, onConfirm, isOpen, testIdBase = 'number-entry-modal' }) {
  const [value, setValue] = useState();

  return (
    <Modal isOpen={isOpen}
      toggle={onCancel}
      size='sm'
      backdrop='static'
    >
      <ModalHeader>
        {title}
      </ModalHeader>
      <ModalBody style={{ padding: 0 }}>
        <div className="col-lg-12">
          {message}
          <input type="text" className="form-control" onChange={(e) => setValue(e.target.value)} {...getTestId(testIdBase, '.', 'input')} />
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="col-lg-12">
          <Button className="float-left mr-3" onClick={onCancel} variant="secondary" {...getTestId(testIdBase, '.', 'close')}>
            <Trans>Close</Trans>
          </Button>
          <Button
            className="float-right"
            onClick={() => {
              onConfirm(value);
            }}
            color="primary"
            {...getTestId(testIdBase, '.', 'confirm')}
          >
            <Trans>Confirm</Trans>
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

NumberEntryModal.PARAMS = PARAMS;

export default NumberEntryModal;
